<template>
  <div class="inline-block relative ml-2" @mouseenter="show" @mouseleave="hide" ref="trigger">
    {{ label }} <i v-if="showIcon" class="fa-sharp fa-info-circle text-accent-500"></i>
    <Teleport to="body">
      <div
        v-if="visible"
        ref="tooltip"
        class="w-48 whitespace-pre-line bg-white text-neutral-600 text-center border border-neutral-300 p-3 text-xs pointer-events-none rounded-sm shadow-sm z-50 fixed"
        :style="tooltipStyle">
        <slot></slot>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    alignRight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      tooltipStyle: {}
    }
  },
  methods: {
    show() {
      const rect = this.$refs.trigger.getBoundingClientRect()
      const tooltipWidth = 192 // w-48 = 12rem

      this.tooltipStyle = {
        left: this.alignRight ? `${rect.right - tooltipWidth}px` : `${rect.left}px`
      }

      this.visible = true

      this.$nextTick(() => {
        const tooltipEl = this.$refs.tooltip
        if (!tooltipEl) return

        const tooltipHeight = tooltipEl.offsetHeight
        if (rect.top + tooltipHeight > window.innerHeight) {
          this.tooltipStyle = {
            ...this.tooltipStyle,
            bottom: `${window.innerHeight - rect.top}px`
          }
        } else {
          this.tooltipStyle = {
            ...this.tooltipStyle,
            top: `${rect.top}px`
          }
        }
      })
    },
    hide() {
      this.visible = false
    }
  }
}
</script>
